module.exports = [{
      plugin: require('../plugins/gatsby-plugin-goatcounter/gatsby-browser.js'),
      options: {"plugins":[],"code":"svrgnty","allowLocal":false,"pixel":true},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
